import type { Filter } from "@/services/collection";
import { type CollectionStatistics, fetchCollectionStatistics } from "@/services/collection";
import { type OnlyPublicProperties } from "@/types";

export function useCollectionStats() {
  const stats = ref<CollectionStatistics>();

  const loadStats = async (filter: OnlyPublicProperties<Filter.Filter>) => {
    stats.value = undefined;
    stats.value = await fetchCollectionStatistics(filter);
  };

  return {
    stats,
    loadStats,
  };
}
